import { useEffect, useState } from "react";
import { getVersionArtifacts } from "./api";
import type { ArtifactBundle } from "./schema";

interface Props {
  sessionId: string;
  workflowName: string;
  version: number;
  createdAt: number;
  grade: string;
  composite: number;
  onHome: () => void;
}

export function VersionSnapshot({
  sessionId,
  workflowName,
  version,
  createdAt,
  grade,
  composite,
  onHome,
}: Props) {
  const [bundle, setBundle] = useState<ArtifactBundle | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getVersionArtifacts(sessionId, version)
      .then((b) => {
        if (!cancelled) setBundle(b);
      })
      .catch((e) => {
        if (!cancelled) setError((e as Error).message);
      });
    return () => {
      cancelled = true;
    };
  }, [sessionId, version]);

  return (
    <div className="canvas">
      <div className="canvas__panel">
        <p className="canvas__eyebrow">Snapshot — v{version} (read-only)</p>
        <h1 className="canvas__display">{workflowName}</h1>
        <p className="canvas__lede">
          Finalized {new Date(createdAt).toISOString().slice(0, 10)} · Grade{" "}
          {grade} · Composite {composite.toFixed(2)}/5.00
        </p>

        {error && <div className="banner banner--error">{error}</div>}

        {bundle && (
          <div className="grade__downloads">
            <a
              className="btn btn--primary"
              href={bundle.baselineRecord.url}
              download={bundle.baselineRecord.filename}
            >
              ↓ {bundle.baselineRecord.filename}
            </a>
            <a
              className="btn btn--ghost"
              href={bundle.canvasJson.url}
              download={bundle.canvasJson.filename}
            >
              ↓ {bundle.canvasJson.filename}
            </a>
            <a
              className="btn btn--ghost"
              href={bundle.governanceReport.url}
              download={bundle.governanceReport.filename}
            >
              ↓ {bundle.governanceReport.filename}
            </a>
          </div>
        )}

        <footer className="canvas__actions">
          <button className="btn btn--ghost" onClick={onHome}>
            ← Home
          </button>
        </footer>
      </div>
    </div>
  );
}
